import {
    BusinessCenter as BusinessCenterIcon,
    Description as DescriptionIcon,
    Diamond as DiamondIcon,
    ShowChart as ShowChartIcon,
} from '@mui/icons-material';
import type { Package } from '../../services/payment.types';

export const packages: Package[] = [
    {
        id: 'basic',
        name: 'Basic',
        transactions: 50,
        price: 29.99,
        icon: DescriptionIcon,
        features: ['Basic tax reporting', 'Manual transaction import', 'Standard support'],
    },
    {
        id: 'standard',
        name: 'Standard',
        transactions: 200,
        price: 59.99,
        icon: ShowChartIcon,
        features: ['Advanced tax reporting', 'API integrations', 'Priority support'],
    },
    {
        id: 'pro',
        name: 'Pro',
        transactions: 1000,
        price: 79.99,
        icon: BusinessCenterIcon,
        features: ['Professional tax reporting', 'Unlimited API integrations', 'Premium support'],
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        transactions: 10000,
        price: 249.99,
        icon: DiamondIcon,
        features: ['Enterprise tax reporting', 'Custom API solutions', 'Dedicated support'],
    },
];
